import React, { useState } from 'react';
import PropTypes, { array } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { shuffle } from 'lodash';
import config from '../../config';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { getLetterType } from '../../util/lettersHelper';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';

import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer, IconSpinner,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';

import facebookImage from '../../assets/allCourseFacebook-1200x630.jpg';
import twitterImage from '../../assets/allCourseTwitter-600x314.jpg';

import SectionFAQAboutHiringOnlineTeachers from './SectionFAQAboutHiringOnlineTeachers/SectionFAQAboutHiringOnlineTeachers';
import SectionTeachersCarousel from './SectionTeachersCarousel/SectionTeachersCarousel';
import SectionFindTeachersByState from './SectionFindTeachersByState/SectionFindTeachersByState';
import SectionHowGetStarted from './SectionHowGetStarted/SectionHowGetStarted';
import SectionWhyHireOnlineTeachersWithAllCourse from './SectionWhyHireOnlineTeachersWithAllCourse/SectionWhyHireOnlineTeachersWithAllCourse';
import SectionHero from './SectionHero/SectionHero';
import SectionFreeCreateProfile from './SectionFreeCreateProfile/SectionFreeCreateProfile';
import SectionTeachersSubjectsByState from './SectionTeachersSubjectsByState/SectionTeachersSubjectsByState';

import css from './OnlineTeachersForHirePage.module.css';
import { getListingsById, getMarketplaceEntities } from "../../ducks/marketplaceData.duck";
import { isTeacherRole, propTypes } from '../../util/types';
import classNames from 'classnames';
import { getSectionsByPage } from '../../util/contentful';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

const ALL_STRING = 'All ';

export const OnlineTeachersForHirePageComponent = props => {
  const {
    history,
    intl,
    location,
    scrollingDisabled,
    currentUser,
    teachers,
    state,
    onManageDisableScrolling,
    searchParams,
    areasCertifiedOptions,
    stateOptions,
    content,
    contentInProgress,
  } = props;

  const [isOpenModal, setOpenModal] = useState(false);
  const isTeacher = isTeacherRole(currentUser);

  const currentSubject = searchParams?.subject ? areasCertifiedOptions.find(i => i.staticUrl === `${searchParams.subject}`) : null;

  const metaSubject = currentSubject?.label.replace(ALL_STRING, '');

  if(currentSubject === undefined) {
    return <NotFoundPage />;
  }

  let article = 'a';
  if(currentSubject) {
    const firstLetterOfCurrentSubject = searchParams?.subject?.substring(0, 1);
    const letterTypeObject = getLetterType(firstLetterOfCurrentSubject);
    const letterType = letterTypeObject.type;
    article = letterType === 'vowel' ? 'an' : 'a';
  }

  const currentState = searchParams?.state ? stateOptions.find(s => s.short === searchParams.state) : null;
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;
  const filteredTeachers = teachers?.filter(t => {
    const { profile } = t?.attributes;
    const { publicData } = profile;
    const { onboardingProcess } = publicData;
    const isNewUser = onboardingProcess && onboardingProcess?.licenses && onboardingProcess?.licenses.length > 0;
    const isTeacherHasState = onboardingProcess && onboardingProcess?.licenses && onboardingProcess?.licenses[0]?.usState !== null;
    if (isNewUser) {
      return isTeacherHasState
    } else {
      return t
    }
  });

  // const sectionsOnPage = getSectionsByPage(currentState?.short, currentSubject?.parent.toLowerCase().replace(' ', '-'), 'OnlineTeachersForHirePage');

  const sections = content?.sections ? content.sections.map(i => {
    const section = i.fields.sectionName.split('-')[0];
    switch (section) {
      case 'how':
        const contentHow = content ? content?.sections.find(e => e.fields.sectionName.split('-')[0] === 'how')?.fields : null;
        return (
          <li className={css.section}>
            <div className={css.sectionContent}>
              <SectionHowGetStarted
                currentUser={currentUser}
                isTeacher={isTeacher}
                handleGetStarted={() => setOpenModal(true)}
                content={contentHow}
              />
            </div>
          </li>
        )
      case 'why':
        const contentWhy = content ? content.sections.find(e => e.fields.sectionName.split('-')[0] === 'why')?.fields : null;
        return (
          <li className={css.section}>
            <div className={css.sectionContent}>
              <SectionWhyHireOnlineTeachersWithAllCourse
                state={currentState}
                subject={currentSubject}
                content={contentWhy}
              />
            </div>
          </li>
        )
      case 'free':
        const contentFree = content ? content?.sections.find(e => e.fields.sectionName.split('-')[0] === 'free')?.fields : null;
        return (
          <li className={classNames(css.section, css.sectionLast)}>
            <div className={css.sectionFreeCreateProfile}>
              <div className={css.sectionContent}>
                <SectionFreeCreateProfile
                  handleGetStarted={() => setOpenModal(true)}
                  currentUser={currentUser}
                  isTeacher={isTeacher}
                  intl={intl}
                  content={contentFree}
                />
              </div>
            </div>
          </li>
        )
      case 'faq':
        const contentFAQ = content ? content?.sections.find(e => e.fields.sectionName.split('-')[0] === 'faq')?.fields : null;
        return (
          <li className={css.sectionContentLastChild}>
            <div className={css.sectionContent}>
              <SectionFAQAboutHiringOnlineTeachers
                state={currentState}
                subject={currentSubject}
                content={contentFAQ}
              />
            </div>
          </li>
        )
    }
  }) : '';


  const schemaTitle = !currentState && !currentSubject ?
    intl.formatMessage({ id: 'OnlineTeachersForHirePage.schemaTitle' }) :
    !!currentState && !currentSubject ?
      intl.formatMessage(
        { id: 'OnlineTeachersForHirePage.schemaTitleWithState' },
        { state: currentState.label, stateAbbreviation: currentState.short.toUpperCase() }
      ) :
      intl.formatMessage(
        { id: 'OnlineTeachersForHirePage.schemaTitleWithStateAndSubject' },
        { subject: metaSubject, state: currentState.label, article }
      );


  const schemaDescription = !currentState && !currentSubject ?
    intl.formatMessage({ id: 'OnlineTeachersForHirePage.schemaDescription' }) :
    !!currentState && !currentSubject ?
      intl.formatMessage(
        { id: 'OnlineTeachersForHirePage.schemaDescriptionWithState' },
        { state: currentState.label, stateAbbreviation: currentState.short.toUpperCase() }
      ) :
      intl.formatMessage(
        { id: 'OnlineTeachersForHirePage.schemaDescriptionWithStateAndSubject' },
        { subject: metaSubject, state: currentState.label, stateAbbreviation: currentState.short.toUpperCase(), article }
      );

  const ogImage = content?.metaImage && `https:${content?.metaImage?.fields?.file?.url}`;

  return (
    <Page
      referrer="strict-origin-when-cross-origin"
      currentUser={currentUser}
      pageName='OnlineTeachingJobsPage'
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      // title={content?.metaTitle || schemaTitle}
      // description={content?.metaDescription || schemaDescription}
      title={schemaTitle}
      description={schemaDescription}
      facebookImages={ogImage && [{
        image: ogImage,
        url: `${ogImage}`,
        width: 1200,
        height: 630,
      }]}
      twitterImages={ogImage && [
        { url: ogImage, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: content?.metaDescription || schemaDescription,
        name: content?.metaTitle || schemaTitle,
        image: ogImage ? [ogImage] : [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer
            isOpenSigUpModal={isOpenModal}
            setOpenSigUpModal={setOpenModal}
            newSearchDesign
            teacherTopbar
          />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          {!contentInProgress ? (
            <>
              <div className={css.heroContainer}>
                <SectionHero
                  rootClassName={css.heroRoot}
                  className={css.hero}
                  history={history}
                  location={location}
                  currentUser={currentUser}
                  isTeacher={isTeacher}
                  intl={intl}
                  state={currentState}
                  subject={currentSubject}
                  handleGetStarted={() => setOpenModal(true)}
                  content={content}
                />
              </div>
              <ul className={css.sections}>
                <li className={css.section}>
                  <div className={css.sectionContentFirstChild}>
                    <SectionTeachersCarousel
                      state={currentState}
                      subject={currentSubject}
                      teachers={filteredTeachers}
                      currentUser={currentUser}
                      content={content}
                    />
                  </div>
                </li>
                <li>
                  <div className={css.sectionContent}>
                    {state ?
                      <SectionTeachersSubjectsByState
                        state={currentState}
                        subject={currentSubject}
                        content={content}
                      /> :
                      <SectionFindTeachersByState state={currentState} content={content} />
                    }
                  </div>
                </li>
                {content ? sections : (
                  <>
                    <li className={css.section}>
                      <div className={css.sectionContent}>
                        <SectionHowGetStarted
                          currentUser={currentUser}
                          isTeacher={isTeacher}
                          handleGetStarted={() => setOpenModal(true)}
                        />
                      </div>
                    </li>
                    <li className={css.section}>
                      <div className={css.sectionContent}>
                        <SectionWhyHireOnlineTeachersWithAllCourse
                          state={currentState}
                          subject={currentSubject}
                        />
                      </div>
                    </li>
                    <li className={classNames(css.section, css.sectionLast)}>
                      <div className={css.sectionFreeCreateProfile}>
                        <div className={css.sectionContent}>
                          <SectionFreeCreateProfile
                            handleGetStarted={() => setOpenModal(true)}
                            currentUser={currentUser}
                            isTeacher={isTeacher}
                            intl={intl}
                          />
                        </div>
                      </div>
                    </li>
                    <li className={css.sectionContentLastChild}>
                      <div className={css.sectionContent}>
                        <SectionFAQAboutHiringOnlineTeachers
                          state={currentState}
                          subject={currentSubject}
                        />
                      </div>
                    </li>
                  </>
                )}
              </ul>
            </>
          ) : (
            <div className={css.loader}>
              <IconSpinner />
            </div>
          )}
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>

      {/*<Modal*/}
      {/*  id="TopbarInviteFriend"*/}
      {/*  isOpen={invitePopUpOpen}*/}
      {/*  onClose={() => setInvitePopUpOpen(false)}*/}
      {/*  usePortal*/}
      {/*  onManageDisableScrolling={onManageDisableScrolling}*/}
      {/*  closeButtonMessage={" "}*/}
      {/*>*/}
      {/*  <ModalInviteFriend*/}
      {/*    currentUser={currentUser}*/}
      {/*    currentPage={"OnlineTeachingJobsPage"}*/}
      {/*    onManageDisableScrolling={onManageDisableScrolling}*/}
      {/*  />*/}
      {/*</Modal>*/}
    </Page>
  );
};

const { bool, object } = PropTypes;

OnlineTeachersForHirePageComponent.defaultProps = {
  listings: [],
  pagination: null,
  searchListingsError: null,
  searchParams: {},
  teachers: [],
  reviews: [],
  areasCertifiedOptions: config.custom.areasCertifiedOptions,
  stateOptions: config.custom.stateOptions,
};

OnlineTeachersForHirePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  listings: array,
  searchInProgress: bool.isRequired,
  searchListingsError: propTypes.error,

  teachers: array,

  fetchTransactionsInProgress: bool.isRequired,
  fetchTransactionsError: propTypes.error,
  reviews: array,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    searchTeachersInProgress,
    searchTeachersError,
    teachers,
    currentPageResultIds,
    searchInProgress,
    searchListingsError,
    fetchTransactionsInProgress,
    fetchTransactionsError,
    reviews,
    transactionRefs,
    searchParams,
    content,
    contentInProgress,
  } = state.OnlineTeachingJobsPage;

  const pageListings = getListingsById(state, currentPageResultIds);

  return {
    currentUser,
    searchTeachersInProgress,
    searchTeachersError,
    teachers,
    scrollingDisabled: isScrollingDisabled(state),
    listings: pageListings,
    searchInProgress,
    searchListingsError,
    fetchTransactionsInProgress,
    fetchTransactionsError,
    reviews,
    transactions: getMarketplaceEntities(state, transactionRefs),
    searchParams,
    content,
    contentInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) => dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const OnlineTeachersForHirePage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(OnlineTeachersForHirePageComponent);

export default OnlineTeachersForHirePage;
